import React, { Component } from "react";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import FlexView from "react-flexview";
import SimpleInput from "../../../../../modules/SimpleInput";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import { modalHotlinTableConfig } from "./config";

class ModalHotline extends Component {
  render() {
    const { visible, onClickClose } = this.props;
    return (
      <React.Fragment>
        <SimpleModal
          title="Cari No.Hotline"
          visible={visible}
          onClickClose={onClickClose}
          content={
            <ModalContainer>
              <FlexView vAlignContent="bottom">
                <SimpleInput
                  id="consumenName"
                  placeholder="Nama Konsumen"
                  containerclassname="width width-250px"
                  label="Nama Konsumen"
                />
                <SimpleButton
                  id="btn_consumen_name"
                  className="margin-bottom-20px"
                  text="Cari"
                />
              </FlexView>
              <FlexView style={{ gap: "20px" }}>
                <div className="flex-1">
                  <SimpleDataTable
                    data={[]}
                    columns={modalHotlinTableConfig}
                    options={{ pagination: false }}
                  />
                </div>
                <SimpleDataTable
                  data={[]}
                  columns={[{ label: "Kode Part" }, { label: "Nama Part" }]}
                  options={{ pagination: false }}
                />
              </FlexView>
            </ModalContainer>
          }
        />
      </React.Fragment>
    );
  }
}

export default ModalHotline;
